export type OrderFinanceReadModelRefresh = () => Promise<unknown> | unknown;

export interface OrderFinanceReadModelRefreshers {
  order: OrderFinanceReadModelRefresh;
  marginHistory: OrderFinanceReadModelRefresh;
  marginExplanation: OrderFinanceReadModelRefresh;
  settlementLedger: OrderFinanceReadModelRefresh;
  settlementReadiness: OrderFinanceReadModelRefresh;
}

/** One refresh seam for every read model affected by settlement/finance writes. */
export async function refreshOrderFinanceReadModels(
  refreshers: OrderFinanceReadModelRefreshers,
): Promise<void> {
  await Promise.all([
    refreshers.order(),
    refreshers.marginHistory(),
    refreshers.marginExplanation(),
    refreshers.settlementLedger(),
    refreshers.settlementReadiness(),
  ]);
}

/** A successful finance mutation is not complete until canonical reads refetch. */
export async function runOrderFinanceMutation<T>(
  mutate: () => Promise<T>,
  refresh: OrderFinanceReadModelRefresh,
): Promise<T> {
  const result = await mutate();
  await refresh();
  return result;
}
